// extracted by mini-css-extract-plugin
export default {"styles":"primaryCareProvider_styles__YUdgE"};